import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { IBookItem } from "~/utils/interface";
import { Book } from "~/components";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

import "swiper/css";
import "swiper/css/navigation";

interface ISliderBooks {
  books: IBookItem[];
  slidesToShow: number;
}

const SliderBooks = ({ books, slidesToShow }: ISliderBooks) => {
  const width = useWindowWidth();

  const mobileCountSlides = width > 992 ? 7 : width < 768 ? 1 : 4;

  return (
    <div>
      {books?.length > mobileCountSlides ? (
        <Swiper
          className="books_slider"
          spaceBetween={16}
          slidesPerView={slidesToShow}
          loop
          navigation
          modules={[Navigation]}
          breakpoints={{
            320: {
              slidesPerView: 2,
            },
            769: {
              slidesPerView: 4,
            },
            1201: {
              slidesPerView: slidesToShow,
            },
          }}
        >
          {books?.map((book, bookId) => {
            return (
              <SwiperSlide key={`${bookId}_book_slider_${book.book_id}`}>
                <Book
                  book_id={book.book_id}
                  peppers={book.peppers}
                  title={book.title}
                  cover={book.cover}
                  tropes={book.tropes}
                  showTropes={false}
                  showPeppers
                  is_free={book.is_free}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div className="grid grid-cols-7 max-lg:grid-cols-4 max-xl:grid-cols-6  gap-4">
          {books?.map((book, bookId) => {
            return (
              <Book
                key={`${bookId}_book_slider_${book.book_id}`}
                book_id={book.book_id}
                peppers={book.peppers}
                title={book.title}
                cover={book.cover}
                tropes={book.tropes}
                showTropes={false}
                showPeppers
                is_free={book.is_free}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

SliderBooks.displayName = "SliderBooks";
export default SliderBooks;
